class Pagination extends HTMLElement {
  constructor () {
    super ()
    this.itemEls = this.querySelectorAll('.js-item')

    this.itemEls.length && this.itemEls.forEach(item => {
      const dataPage = item.dataset.page
      const urlParams = new URLSearchParams(window.location.search)
      urlParams.set('page', dataPage)
      const url = window.location.pathname + '?' + urlParams.toString()

      const linkEl = item.querySelector('a')
      linkEl && linkEl.setAttribute('href', url)
    })
  }
}

window.customElements.define('custom-pagination', Pagination)